import $ from "jquery";

$(".sb_featured-excursions_items").on("dragStart.flickity", (event) => {
    $("body").addClass("s_is-dragging");
    $(event.currentTarget).addClass("s_is-dragging");
});

$(".sb_featured-excursions_items").on("dragEnd.flickity", (event) => {
    $("body").removeClass("s_is-dragging");
    $(event.currentTarget).removeClass("s_is-dragging");
});
